/**
 * @class
 * Generates network request descriptor for entire application
 */      
export default class NetworkRequestGenerator {

}